module.exports = __webpack_public_path__ + "media/02 patriotism.3d15d196.mp3";